module.exports = __webpack_public_path__ + "img/deepwater-green1.c9e53bcd.png";